import { Edit, Form, Input, Switch, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import "react-mde/lib/styles/css/react-mde-all.css";
import dayjs from "dayjs";

export const DisputeEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, formLoading } = useForm<any>();

  const { queryResult } = useShow<any>();
  const { data, isLoading } = queryResult;
  const record: any = data?.data;

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={isLoading || formLoading}
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Order ID"
          name="order"
          initialValue={record?.data.order?.orderId}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Transaction Amount($)"
          name="transactionAmount"
          initialValue={record?.data.transactionAmount}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="User Email"
          name="user"
          initialValue={record?.data.user?.email}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Paypal Email"
          name="paypalEmail"
          initialValue={record?.data.paypalEmail}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Paypal Transaction ID"
          name="paypalTransactionId"
          initialValue={record?.data.paypalTransactionId}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Paypal Transaction Date"
          name="paypalTransactionDate"
          initialValue={dayjs(record?.data.paypalTransactionDate).format(
            "MM-DD-YYYY HH:mm A"
          )}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Created At"
          name="createdAt"
          initialValue={dayjs(record?.data.createdAt).format(
            "MM-DD-YYYY HH:mm A"
          )}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Paypal Case ID"
          name="paypalCaseId"
          initialValue={record?.data.paypalCaseId}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Refund Type"
          name="refundType"
          initialValue={record?.data.refundType}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Refund Amount"
          name="refundAmount"
          initialValue={record?.data.refundAmount}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Comments"
          name="comments"
          initialValue={record?.data.comments}
        >
          <textarea
            style={{
              width: "100%",
              color: "#626262",
              border: "1px solid #d9d9d9",
              padding: "4px 12px",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          />
        </Form.Item>
        <Form.Item
          label="Is Resolved"
          name="isResolved"
          initialValue={record?.data.isResolved}
        >
          <Switch disabled defaultChecked={record?.data?.isResolved} />
        </Form.Item>
      </Form>
    </Edit>
  );
};
